import { render, staticRenderFns } from "./GenericModal.vue?vue&type=template&id=629ee060&"
import script from "./GenericModal.vue?vue&type=script&lang=js&"
export * from "./GenericModal.vue?vue&type=script&lang=js&"
import style0 from "./GenericModal.vue?vue&type=style&index=0&id=629ee060&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports